import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';
import { GlobalStyles, KeyboardDetectionProvider, LoadingIndicator } from '@spotify-internal/encore-web';

import { initialize as initSentry } from 'lib/client/sentry/sentry';
import MarketInfoProvider, { getLocaleForMarket, initiateMarket } from 'context/MarketInfo/MarketInfoProvider';
import ConfigProvider from 'context/Config/ConfigProvider';
import UserInfoProvider from 'context/UserInfo/UserInfoProvider';
import RemoteConfigProvider from 'context/Experimentation/ExperimentationProvider';
import SettingsProvider from 'context/Settings/SettingsProvider';
import { initI18n } from 'lib/shared/i18n/i18n';

const App = lazy(() => import('containers/App/App'));

import './index.scss';

initSentry();

const market = initiateMarket();
initI18n(getLocaleForMarket(market));

if (process.env.NODE_ENV !== 'production') {
  const axe = require('@axe-core/react');
  axe(React, ReactDOM, 1000);
}

ReactDOM.render(
  <>
    <GlobalStyles />
    <Router basename={market}>
      <HelmetProvider>
        <MarketInfoProvider market={market}>
          <ConfigProvider>
            <UserInfoProvider>
              <RemoteConfigProvider>
                <SettingsProvider>
                  <KeyboardDetectionProvider>
                    <Suspense fallback={<LoadingIndicator />}>
                      <App market={market} />
                    </Suspense>
                  </KeyboardDetectionProvider>
                </SettingsProvider>
              </RemoteConfigProvider>
            </UserInfoProvider>
          </ConfigProvider>
        </MarketInfoProvider>
      </HelmetProvider>
    </Router>
  </>,
  document.getElementById('root'),
);
